import { render, staticRenderFns } from "./ApproveIdea.vue?vue&type=template&id=22c8d66c&"
import script from "./ApproveIdea.vue?vue&type=script&lang=js&"
export * from "./ApproveIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports